import { BadgeConfiguration } from "../model/BadgeConfiguration";

const DEFAULT_PRIMARY_COLOUR = "#1c5ca2";
const DEFAULT_SECONDARY_COLOUR = "#304c75";
const DEFAULT_ROLE_TEXT_COLOUR = "#ffffff";

const DEFAULT_TEMPLATE_ID = 1;

export interface BadgeConfigurationRequest {
    badgeName: string;
    primaryColour: string;
    secondaryColour: string;
    roleTextColour: string;
    templateId: number|null;
    propertyOverrides?: Record<string, string>|null;

    base64LogoImage: string;
    logoImageContentType: string;

    base64BackImage: string;
    backImageContentType: string;

    // Stand-in portrait used on badges for people who have no photo of their own.
    base64DefaultPictureImage: string;
    defaultPictureImageContentType: string;
}

export const BadgeConfigurationRequestFromBadgeConfiguration = (bc: BadgeConfiguration): BadgeConfigurationRequest => {
    return {
        badgeName: bc.badgeName,
        primaryColour: bc.primaryColour,
        secondaryColour: bc.secondaryColour,
        roleTextColour: bc.roleTextColour,
        templateId: bc.templateId || DEFAULT_TEMPLATE_ID,
        propertyOverrides: bc.propertyOverrides || null,

        base64LogoImage: bc.logoImage ? bc.logoImage.data : null,
        logoImageContentType: bc.logoImage ? bc.logoImage.contentType : null,

        base64BackImage: bc.backImage ? bc.backImage.data : null,
        backImageContentType: bc.backImage ? bc.backImage.contentType : null,

        base64DefaultPictureImage: bc.defaultPicture ? bc.defaultPicture.data : null,
        defaultPictureImageContentType: bc.defaultPicture ? bc.defaultPicture.contentType : null
    };
};

export const DefaultBadgeConfigurationRequest = () => {
    return {
        badgeName: "",
        primaryColour: DEFAULT_PRIMARY_COLOUR,
        secondaryColour: DEFAULT_SECONDARY_COLOUR,
        roleTextColour: DEFAULT_ROLE_TEXT_COLOUR,
        templateId: DEFAULT_TEMPLATE_ID,
        base64LogoImage: null,
        logoImageContentType: null,
        base64BackImage: null,
        backImageContentType: null,
        base64DefaultPictureImage: null,
        defaultPictureImageContentType: null
    };
};